<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->

<div class="mt-4 p-3" style="background: #f7f7f7; border-radius: 6px">
  <p class="font-medium mb-1">{{ title }}</p>
  <p class="mb-2" style="color: #666; font-size: 12px">
    The therapist gets an email with a link to a spreadsheet of the feedback for
    the sessions you tick. The link works for one day.
  </p>
  <p *ngIf="completedSessions.length === 0">No completed sessions yet.</p>
  <div *ngIf="completedSessions.length > 1" class="mb-2">
    <label
      nz-checkbox
      [(ngModel)]="allChecked"
      [nzIndeterminate]="indeterminate"
      (ngModelChange)="onAllCheckedChange($event)"
    >
      Select all completed sessions
    </label>
  </div>
  <div *ngFor="let session of completedSessions" class="mb-1">
    <label
      nz-checkbox
      [(ngModel)]="session.checked"
      (ngModelChange)="onSessionCheckedChange()"
    >
      {{ session.label }}
    </label>
  </div>
</div>
